namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'dashboard-blog-feed-component-template',
        bindings: {}
    })
    class DashboardBlogFeedComponent {
        public posts = null;

        public constructor(public RepositoryService: RepositoryService) {
            this.getBlogPosts();
        }

        getBlogPosts() {
            this.RepositoryService.getBlogFeed().then((posts) => {
                this.posts = posts;
            });
        }
    }
}